/**
 * 時事評論
 * Created at 2021-10-03 10:57
 * @author teapot
 */
import { Image, List } from "antd";
import { useEffect, useState, useRef } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import Api from "../../api";
import { useAppSelector, useAppDispatch } from "../../app/hooks";
import { RootState } from "../../app/store";
import HeadView from "../../components/head/HeadView";
import Config from "../../config";
import { DetailsParams } from "../../model/HomeModel";
import { memberAsync } from "../../store/OtherStore";
import "./index.css";
import { Pagination } from "antd";
import MemberAddress from "./MemberAddress";
const Member = () => {
  const { memberPic, memberTitle, memberTrend } = useAppSelector(
    (state: RootState) => state.other
  );
  const dispatch = useAppDispatch();
  const itemref = useRef(null);
  const history = useHistory();
  const { t } = useTranslation();
  let [page, setPage] = useState(0);
  let [pageSize, setpPageSize] = useState(9);
  let [currentpage, setCurrentpage] = useState(1);
  const change = (page: any) => {
    setPage(page * 10 - 10);
    setpPageSize(page * 10 - 1);
    setCurrentpage(page);
  };
  let tot = 0;
  memberTrend.forEach((x) => {
    tot += x.arcticles.length;
  });
  const init = (i: number, p: number) => {
    // console.log("分页输出问题", i, p);
    const sbb = document.querySelectorAll(".member-display").length;
    document.querySelectorAll(".member-display").forEach((x, i) => {
      x.classList.add("dataItem");
    });
    // console.log(p, sbb);
    if (p <= sbb) {
      for (i; i <= p; i++) {
        // console.log(document.querySelectorAll(".member-display")[i].classList);
        document
          .querySelectorAll(".member-display")
          [i].classList.remove("dataItem");
      }
    } else {
      // console.log("另外一种情况");
      for (i; i < sbb; i++) {
        document
          .querySelectorAll(".member-display")
          [i].classList.remove("dataItem");
      }
    }
  };
  setTimeout(() => {
    init(page, pageSize);
  });
  useEffect(() => {
    dispatch(memberAsync(1));
  }, [dispatch]);
  const Fenye = () => {
    return (
      <Pagination
        style={{ marginTop: "10px" }}
        defaultPageSize={10}
        current={currentpage}
        total={tot}
        showTotal={(total) => `共${total}篇文章`}
        onChange={change}
      />
    );
  };

  return (
    <div className="member">
      <MemberAddress></MemberAddress>
      {/* <div className="line"></div> */}
      <HeadView title={memberTitle} imgs={`${Config.MAIN_URL}${memberPic}`} />
      <List
        dataSource={memberTrend}
        locale={{ emptyText: t("nodata") }}
        renderItem={(item, index) => {
          return (
            <List.Item key={index} className="member-list" onClick={() => {}}>
              <div className="member-item">
                {item.arcticles &&
                  item.arcticles.map((value, i) => {
                    return (
                      <div>
                        <div
                          ref={itemref}
                          key={i}
                          className="tinktank-item-middle-content tinktank-item-middle-content-phone member-display dataItem"
                          onClick={() => {
                            if (value.url) {
                              window.location.href = value.url;
                            } else if (value.uuid) {
                              // history.push("/commentary/member_date_comment", {
                              //   url: Api.member_details,
                              //   uuid: value.uuid,
                              //   methods: "get",
                              //   memberImg: value.img,
                              //   memberName: value.name,
                              //   education: value.education,
                              //   position: value.position,
                              // } as DetailsParams);

                              // console.log('==为啥没有执行这一段代码==');
                              // console.log((unescape(encodeURIComponent(value.img))));
                              // console.log(decodeURIComponent(escape(((unescape(encodeURIComponent(value.img)))))));
                              // console.log('====================================');
                              let path = window.btoa(
                                JSON.stringify({
                                  url: Api.member_details,
                                  uuid: value.uuid,
                                  methods: "get",
                                  memberImg: encodeURIComponent(value.img),
                                  memberName: encodeURIComponent(value.name),
                                  education: encodeURIComponent(
                                    value.education
                                  ),
                                  position: encodeURIComponent(value.position),
                                })
                              );
                              // btoa(unescape(encodeURIComponent(path)))
                              history.push(
                                `/commentary/member_date_comment/${path}`,
                                {
                                  url: Api.member_details,
                                  uuid: value.uuid,
                                  methods: "get",
                                  memberImg: value.img,
                                  memberName: value.name,
                                  education: value.education,
                                  position: value.position,
                                }
                              );
                            }
                          }}
                        >
                          {/* <Image
                            width={'10vw'}
                            // height={159}
                            preview={false}
                            src={`${Config.MAIN_URL}${item.im g}`}
                            className="member-item-img member-item-img-phone"
                          /> */}
                          <div
                            className="lef"
                            style={{
                              backgroundImage: `url(${Config.MAIN_URL}${value.pageImg})`,
                            }}
                          ></div>
                          <div className="member-right">
                            <div className=" memberitem-head news-item-image-title-phone">
                              <span className="member-time"> {value.time}</span>{" "}
                              <span
                                style={{ marginLeft: "5px" }}
                                className="member-time"
                              >
                                {value.name}
                              </span>
                            </div>
                            <div className="member-article">
                              {" "}
                              {value.article}{" "}
                            </div>
                            <div className="member-content">
                              {value.content}
                            </div>
                            <div className="menber-bottom" />
                          </div>
                        </div>
                        {/* <div className="menber-bottom"/> */}
                      </div>
                    );
                  })}
              </div>
            </List.Item>
          );
        }}
      />
      <Fenye></Fenye>
    </div>
  );
};

export default Member;
